export default {
  // Allgemein
  language_picker_helper: "Elige un idioma",
  languages: {
    english: "Inglés",
    german: "Alemán",
    spanish: "Español"
  },
  languagesCodes: {
    english: "GB",
    german: "DE",
    spanish: "ES"
  },
  langcodeShort: "ES",
  langcode: "es-ES",
  greeting: "Hola",
  unexpectedError: "Ocurrió un error desconocido",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sabado",
  sunday: "Domingo",
  username: "Nombre de usuario",
  password: "Contraseña",
  logout: "Cerrar sesión",
  since: "desde",
  clock: "reloj",
  back: "atrás",
  deviceConfig: "Abrir Configuración del dispositivo",
  active: "activo",
  inactive: "inactivo",
  save: "guardar",
  absence: "ausencia",
  userIsWorkingInProject: "El empleado está trabajando en un proyecto",
  all: "Todos",
  delete: "borrar",
  send: "enviar",
  date: "fecha",
  search: "Búsqueda",
  legend: "Leyenda",
  time: "tiempo",
  comment: "commentario",
  passwordNoMatch: "las contraseñas no coinciden",
  resetPassOnLogin: "Restablecer contraseña al iniciar sesión",
  cancel: "cancelar",
  passwordSaved: "Contraseña guardada",
  changePasswordQuestion: "Quieren cambiar la contraseña",
  insertPassword: "Ingrese contraseña",
  confirmPassword: "Confirmar contraseña",
  insertAdminPassword: "Admin passwort insert",
  confirm: "Contraseña",
  history: "Historia",
  workTime: "el tiempo de trabajo",
  pause: "pausa",
  monthlyWorkTime: "El tiempo de trabajo mensual es",
  showDeletedBookingLines: "Ver reservas eliminadas",
  hideDeletedBookingLines: "Ocultar reservas eliminadas",
  addTime: "añadir tiempo",
  project: "proyecto",
  add: "añadir",
  changeTime: "cambiar tiempo",
  timestamp: "tiempo",
  duration: "duración",
  coming: "Venir",
  going: "Salir",
  changeLine: "cambiar linea",
  timeOverlapse: "El tiempo se superpone con otra reserva",
  timeToBigFor: "El tiempo no puede ser mas grande que",
  be: "ser",
  editBookingLineWithoutComment: "Estan seguro que quieren añadir una reserva corregido sin commentario",
  timeNotEntered: "no se ingresó el tiempo",
  statusNotEntered: "no se ingresó el estado",
  worktimeIs: "el tiempo de trabajo es",
  pauseTimeIs: "el tiempo de pausa es",
  accept: "aceptar",
  decline: "declinar",
  declined: "Declined",
  reason: "razón",
  absenceReason: "absence reason",
  prevDay: "dia anterior",
  nextDay: "dia siguiente",
  prevMonth: "mes anterior",
  nextMonth: "mes siguiente",
  successfullyTransmitted: "Transmitido con éxito",
  cobiServerNotRunning: "Servido de COBI.time: Sin reacción",
  cobiServerUp: "Conexión al servido de COBI.time reconstruido con éxito",
  finished: "terminado",
  or: "or",
  started: "started",
  hrs: "hours",
  activity: "activity",
  noRight: "User has no rights",
  publicHolidays: "public holidays",
  publicHoliday: "Public holiday",
  state: "State",
  import: "import",
  changesWillBeLostMessage: "Any unsaved changes will be lost.",
  workDay: "Work day",
  request: "Request",
  select: "Select",
  month: "Month",
  publicHolidaysLetter: "H",
  workDayLetter: "W",
  vacation: "Vacation",
  errorByUser: "Error by user",
  from: "From",
  until: "Until",
  attachments: "Attachments",
  onSwitch: "on",
  offSwitch: "off",
  yes: "yes",
  no: "no",

  // Auth
  userPin: "pin de usuario",
  resetPass: "Reiniciar Contraseña",

  // FaceLogin.vue
  faceFound: "cara reconocida! Intenta de iniciar sesión",
  faceLoginHelp: "Por favor quedanse quieto durante el processo de reconocimiento de rostro",
  pleaseEnterPin: "Por favor ingrésen el PIN para el login!",
  enterPin: "ingrése el PIN",
  employeeNotRecognized: "empleado no reconocido!",
  faceLoginRestarting: "reconocimiento de rostro va a reiniciar",

  // Menu.vue
  timekeeping: "Registrar el tiempo",
  manualTimekeeping: "Registrar el tiempo manual",
  administration: "Administración",
  presencelist: "Lista de presencia",
  mainmenu: "Menú principal",

  // Usermenu.vue
  notifications: "Notificaciones",
  newNotification: "nuevas notificaciones",
  openNotification: "abrir notificaciones",
  userFunctions: "funciones de usuario",
  showHistory: "mostrar historia",
  absenceRequest: "solicitud de ausencia",
  changePic: "cambiar foto",
  noPictureUploaded: "no se subió una foto",
  messages: "Noticias",
  subject: "Sujeta",
  chooseMessage: "Por favor elija un mensaje",
  deleteMessagesQuestion: "Realmente quieres eliminar los mensajes",
  userInfo: "User info",

  // Status
  absent: "Ausente",
  present: "Presente",
  inproject: "En un proyecto",
  inpause: "En la pausa",

  // Administration.vue
  userAdministration: "administración de usuario",
  generalSettings: "ajustes generales",
  changeLogo: "cambiar logo",
  resetLogo: "reiniciar Logo",
  upload: "subir",
  absenceReasons: "razónes para ausencia",
  manage: "administrar",
  factorAuth: "Autenticación de 2 factores (Cara & Pin)",
  absenceAdministration: "Administración de ausencia",
  importSapUser: "importación de SAP usuarios",
  importUser: "importación de usuarios",
  editUser: "editar usuario",
  projectAdministration: "administración de proyecto",
  sapUserCodeIsMissingError: "Beim Benutzer {0} fehlt der SAP Benutzercode!",
  userWithSameCodeError: "Benutzer mit dem gleichen SAP Benutzercode ist schon vorhanden",
  settingSuccessfulSaved: "Setting was saved successfully!",
  TimeAccountRecalculation: "recalculate timeaccounts",
  startTimeAccountRecalculation: "Berechnung starten",
  timeAccountAlreadyRecalculateError: "Timeaccounts are already recalculating",

  //Settings.vue
  stageProjectsAllowed: "Activate booking on projects from project management?",
  settingsWasSaved: "Settings were saved",
  stageProjectsWithoutPermissions: "Activate authorization system for projects from project management?",
  serviceCallsAllowed: "Activate booking on service calls? ",
  serviceCallsWithoutPermissions: "Activate authorization system for service calls? ",
  showAbsenceApprovalsInPresentList: "Show absence requests in the presence list ",
  financeProjectsAllowed: "Activate posting to financial projects?",
  colorCode: "Color code",
  requireLocation: "Require location selection",
  requireLocation: "Selección de ubicación obligatoria",
  chooseLocation: "Seleccionar ubicación",
  settingsTitle: "Configuración",
  settingsTabGeneral: "General",
  settingsTabSecurity: "Seguridad",
  settingsTabTimeManagement: "Gestión del tiempo",
  settingsTabProjects: "Proyectos",
  settingsTabServiceCalls: "Llamadas de servicio",
  settingsTabBusinessTrips: "Viajes de negocios",
  settingsTabCalculation: "Cálculo",
  timeAccountsWarningGeneral:
    "Advertencia: Inicia un recálculo en todo el sistema de todas las cuentas de tiempo. El proceso puede prolongarse y afectar al rendimiento del sistema. ¿Desea continuar?",
  startRecalculationRequest: "¿Iniciar el recálculo de cuentas de tiempo?",
  timeAccountsWarningText:
    "¡Advertencia! Esta acción inicia un recálculo completo de todas las cuentas de tiempo del sistema. El proceso puede tardar y ralentizar temporalmente la interfaz.",

  //UserAdministration
  userHasNoTeam: "User has no SAP team",
  userInSAPNotFound: "User not found in SAP",
  employeeIsInactiveInSAP: "User is inactive in SAP",
  userHasActiveTimeAccount: "User can't be deleted as long as a timeaccount is active",
  userHasActiveHolidayAccount: "User can't be deleted as long as a holidayaccount is active",
  userDeleteMessage: "Do you really want to delete the following user:",
  holidayDeleteMessage: "Do you really want to delete the following Holiday:",
  activateUser: "activate user",
  showInactiveUser: "show inactive user",
  hideInactiveUser: "hide inactive user",
  usersSuccessfulDelete: "Users were successfully deactivated",
  publicHolidaysAdministration: "Public Holidays Administration",
  userCodeLengthError: "User code cannot be longer than 20 characters",
  team: "Equipo",

  //EditUser
  validFrom: "Valid from:",
  validUntil: "Valid until:",
  timeModel: "Time model",
  autoModel: "Automatische Zeitmodell",
  startTimeHours: "Start value hours",
  dateNoSelectedError: "Date not selected",
  vacationDays: "Vocation days",
  userRightInfo: "Benutzer kann auf die Zeiterfassung zugreifen und Arbeitszeit buchen.",
  projectUserRightInfo: "Benutzer kann die Arbeitszeit auf den Projekten buchen.",
  projectManagerRightInfo: "Benutzer kann auf manuelle Zeiterfassung zugreifen und Arbeitszeit für ausgewählten Tagen buchen.",
  userManagerRightInfo: "Ermöglicht die Mitarbeiter zu administrieren und Projekten an die Mitarbeiter zuweisen.",
  presencelistRightInfo: "Benutzer kann auf die Anwesenheitsliste zugreifen und anwesende Mitarbeiter von eigener Abteilung sehen.",
  cheifPresencelistRightInfo: "Benutzer kann auf die Anwesenheitsliste zugreifen und alle anwesenden Mitarbeiter sehen.",
  timesCorrectionRightInfo: "Benutzer kann die Arbeitszeit korrigieren.",
  seeTimesRightInfo: "Benutzer kann die Arbeitszeit von anderem Mitarbeiter ansehen.",
  notEnoughHolidaysLeft: "Not enough vacation days",
  groupSaveSuccessful: "Groups for user {0} were saved successfully!",
  editHolidayAccount: "Edit holiday account",
  projectAndPauseTimeManipulation: "Correct project and break times",

  //Public Holidays
  sameDateForHolidaysError: "An absence for this Date already exists",
  addNewHoliday: "Create a new holiday",
  deleteHolidayMessage: "Are you sure you want to remove the following holiday?",
  importHolidays: "Import public holidays",
  holidaySuccessfulDeletedMessage: "Holiday was successfully deleted",
  enterHolidayName: "Enter name",
  sameHolidayDateError: "An absence has already been entered for {0}",
  holidaysWarning: "Warning",
  saveHolidayMessage: "Do you wish to save your changes?",
  takeOverHolidayToNextYear: "Take over into the next year",
  timeAccountsRecalculateAlert: "Zeitkonten werden neu berechnet. Bitte warten sie!",
  holidaysBookingProcess: "Speicherung ist nicht möglich! Zeitkonten werden gerade neu berechnet",
  holidaysNameLengthError: "Holiday name cannot be longer than 100 characters",

  // Defaultclient.vue
  monthlyHistory: "Historia mensual",
  chooseProject: "elegir proyecto",
  chooseFinancialProject: "Choose financial Project",
  chooseCustomer: "Geschäftspartner auswählen",
  chooseServiceCall: "Serviceabruf auswählen",
  recordTime: "registrar el tiempo después",
  chooseProjectError: "Please choose a project",
  chooseStageError: "Please choose a service call",
  WorkAlreadyStartedError: "Arbeitstag wurde schon gestartet",
  WorkWasNotStartedError: "Arbeitstag muss erst gestartet werden",
  PauseAlreadyStartedError: "Pause wurde schon gestartet",
  PauseWasNotStartedError: "Pause wurde noch nicht gestartet",
  ProjectAlreadyStartedError: "Projekt wurde schon gestartet",
  ProjectWasNotStartedError: "Projekt wurde noch nicht gestartet",
  absenceErrorByBookingLinesCorrection: "There is an absence for date: {0}",
  financeProjects: "Finance Projects",

  // Presencelist.vue
  attendancestatus: "estado de presencia",
  presentInfoText: "Un hombre verde o una mapa de color verde significa que el empleado esta en el trabajo",
  inPauseInfoText: "Un signo de café amarillo significa que el empleado esta en pausa",
  absentInfoText: "Un hombre rojo o una mapa de color rojo significa que el empleado no está en el trabajo",
  showLegend: "mostrar leyenda",
  timeDot: "marca de tiempo",
  showOnlyPresentEmployee: "Solo ver empleados presentes",
  searchHere: "ingresar búsqueda aqui",
  switchToTableMode: "Cambiar al vista de tabla",
  switchToCardMode: "Cambiar al vista de cuadro",
  hideDeletedBookings: "Hide deleted bookings",
  showDeletedBookings: "Show deleted bookings",
  editHistory: "Edit history",
  sameTimeError: "Less than a minute has passed since the last booking",
  addNewBookingLine: "Add new line",
  presencelistInfoIsDeprecated: "Presence information is out of date",
  noTimeAccountLineForDay: "No time account for this day",
  noRightForStartAndEndTimeCorrection: "User has no rights to correct start and end times",

  //EmployeeInformation
  pauseTimeDebit: "Pausezeit geblieben",

  // Simpleclient.vue
  employee: "empleado",
  employees: "empleados",
  nonBillableTime: "tiempo no facturable",
  startTime: "Hora de inicio",
  endTime: "Hora de final",
  pauseStart: "Empezar pausa",
  pauseEnd: "Terminar pausa",
  projectStart: "Empezar proyecto",
  projectEnd: "Terminar proyecto",
  activityType: "tipo de actividad",
  financeProject: "projecto financiero",
  sumPause: "suma de pausa",
  sumWorkTime: "Worktime sum",
  serviceCallCustomer: "Customer",
  costCentre: "centro de coste",
  postWorktime: "reservar el tiempo de trabajo",
  dateInFuture: "la fecha es en el futuro",
  dateMissing: "la fecha falta",
  startTimeMissing: "La hora de inicio falta",
  endTimeMissing: "La hora de final falta",
  endTimeBeforeStart: "La hora de final del trabajo debe ser después de la hora de inicio del trabajo",
  pauseEndBeforeStart: "la hora de final de pausa debe ser después de la hora de inicio de pausa",
  pauseEndMissing: "la hora de final de pausa falta",
  pauseStartAndEndBeforeStart: "la hora de inicio de pausa y la hora de final de pausa debe ser después de la hora de inicio",
  pauseStartAndEndAfterEnd: "el inicio de pausa y el final de pausa debe ser antés de la hora de final",
  worktimeAdded: "se agregó el tiempo de trabajo",
  simpleClientErrorAbsences: "Cannot proceed; an absence was entered for this date",
  timePeriodsOverlapError: "Cannot proceed; time periods overlap",
  effectiveTimeError: "Effective Work Time must be equal to or greater than zero",
  notTimeAccountForUserError: "No Time Account was created for this user",
  dateOutOfTimeAccountRange: "Date is out of time account valid range",
  ProjectStageNotSelected: "Stage is missing",
  stageIsRequired: "Stage is required!",
  serviceCallIsRequired: "ServiceCall is required!",
  activityIsRequired: "Activity is required!",

  // Start.vue
  configure: "configurar",
  deviceMode: "el modo de dispositivo",
  terminalMode: "el modo de terminal",

  // UserMessageDialog.vue
  receivedOn: "Recibido el",
  readUnread: "leer /marcar como no leído",

  // AbsenceDialog.vue
  sendAbsence: "enviar ausencia",
  requestAbsence: "preguntar por ausencia",
  chooseAbsenceRange: "Por favor elige un periodo de ausencia",
  absenceRequestSuccess: "preguntado por ausencia exitoso",
  wrongFileFormat: "Falsches dateiformat",

  // AbsenceCalendar.vue
  absenceType: "tipos de ausencia",
  colorLegend: "leyenda de colores",
  vacationRequestsConfirmed: "solicitudes de vacaciones cuales son aún no confirmado",
  absenceOverview: "resumen de ausencia",
  showColorLegend: "mostrar leyenda de colores",
  absenceNeedToConfirm: "ausencia debe ser confirmado",
  hideColorLegend: "oculatar leyenda de colores",
  normalWorkDay: "dia de trabajo normal",
  closedTimeaccountWorkDay: "Closed time account",
  showWorkTime: "mostrar tiempo de trabajo",
  acceptAbsenceWarning: "Quieren aceptar la solicitud de ausencia",
  declineAbsenceWarning: "Quieren declinar la solicitud de ausencia",
  absenceFromAccept: "Estan seguro que quieren aceptar la ausencia de ",
  absenceFromDecline: "Estan seguro que quieren declinar la ausencia de ",
  fromTheEmployee: "del empleado",
  savingAbsences: "Guardar razones de ausencia en base de datos",
  absencesSaved: "Razones de ausencia actualizado con éxitoso",
  getAbsences: "Hole Abwesenheitsgründe aus SAP",
  saveAbsence: "Guardar ausencias",
  absenceOverlapError: "Abwesenheiten überschneiden sich!",
  notEnoughVacationDays: "Mitarbeiter hat nicht genug Urlaubstagen",
  NotEnoughVacationDaysForUser: "{0} has not enough vacation days",

  //AbsenceOverview
  remainingHoliday: "Remaining Holiday",
  changesOverview: "Change overview",
  addedAbsences: "Hinzugefügte Abwesenheiten",
  deletedAbsences: "Gelöschte Abwesenheiten",
  approvedAbsences: "Angenommene Abwesenheiten",
  declinedAbsences: "Abgelehnte Abwesenheiten",
  changedAbsences: "Changed absences",
  selectedDays: "Selected Days",
  absencesForApproval: "Absences for approval",
  absenceAprrovalReasonLengthError: "Reason cannot be longer than 100 characters",
  chooseAbsencetype: "choose absence type",
  absenceIsPast: "Absence change for {0} is not possible. The change is far in the past ",
  userHasNoTimeAccountLineForDay: "Bei Benutzer {0} ist keine Zeitkonto für ausgewählte Datum {1} angelegt",
  shiftSelectHint: "Mantén Mayús + Clic izquierdo para seleccionar un rango de fechas",

  // About.vue
  licenseValidUntil: "licencia válida hasta",
  noExpiryDate: "sin fecha de caducidad",

  // History.vue
  statusWorkStart: "Trabajo empezado",
  statusWorkEnd: "Trabajo terminado",
  statusPauseStart: "Pausa empezado",
  statusPauseEnd: "Pausa terminado",
  usergroups: "Grupo de usuarios",
  getSAPUsers: "Cosiguiendo usuarios de la base de datos de SAP",
  importSAPUsers: "Importando empleado de SAP",
  startPassword: "Por favor ingresé la contraseña de inicio",
  noUserSelected: "Ningun usuario esta seleccionado",
  userSuccessfullyCreated: "Usuarios estan creado exitosamente",
  sapExternalUser: "Número de empleado externo de SAP",
  sapUserCode: "Código de usuario de SAP",
  startPass: "Iniciar contraseña:",
  sapImport: "SAP importación",
  name: "Nombre",
  settingsSaved: "Configuraciones guardadas exitosamente",
  chooseSettings: "Por favor rellena todo los campos de la configuración",
  timeErrorLastBookingLine: "Error del tiempo ingresada: Desde la última reserva ha pasado menos de un minuto",
  deleteBookingLineQuestion: "Quieren eliminar la ultima línea",
  startPause: "Inicio de Pausa exitoso",
  endPause: "Fin de la pausa exitoso",
  endPauseTime: "El tiempo de pausa es: ",
  startProject: "Inicio del proyecto : {0} exitoso",
  endProject: "Fin del proyecto exitoso",
  startWork: "Inicio del trabajo exitoso",
  endWork: "Fin del trabajo exitoso! El tiempo trabajado es: {0}",
  newProjectLogic: "Etapas de proyectos",
  endWorkWithoutTime: "Fin del trabajo exitoso!",
  chooseStage: "Eligé una etapa del proyecto",
  chooseActivity: "Choose activity",
  stage: "Etapa",
  editWorkTimeAccount: "Arbeitszeitkonto bearbeiten",
  worktimeAccounts: "Arbeitszeitkonten",

  dataSendSuccessfully: "Daten erfolgreich gesendet",
  timeModelDeleted: "Tageszeitmodell erfolgreich gelöscht",
  activeWeekModelError: "Löschen/Ändern nicht möglich! Es gibt ein aktives Wochenmodell zu diesem Tagesmodell!",
  activeTimeAccountError: "Löschen/Ändern nicht möglich! Es gibt ein aktives Zeitkonto mit diesem Wochenmodell",
  weekModelDeleted: "Wochenzeitmodell erfolgreich gelöscht",
  weekModelWithoutNameNotAllowed: "Wochenzeitmodell ohne Bezeichnung nicht erlaubt",
  timeAccountIs: "Zeitkonto beträgt",
  noTimeAccountSet: "Kein Zeitkonto hinterlegt",
  timeAccountNotAccurate: "Zeitkonto berechnung erfolgt am nächsten Tag",
  deleteTimeAccount:
    "Möchten Sie wirklich dieses Zeitkonto deaktivieren? Das Konto wird mit den aktuellen Zeiten geschlossen. Offene Buchungen werden nicht beachtet!!",
  closeTimeAccount: "Zeitkonto schließen",
  absenceForDayExists: "Für diesen Tag liegt eine Abwesenheit vor",
  workTimeHover: "Work time",
  pauseTimeHover: "Break time",
  projectTimeHover: "Project time",
  bookedSumIs: "Heutige Arbeitsstunden",
  bookedSumDebit: "Sollstunden",
  difference: "difference",
  showOvertimeDetails: "show details",
  hideOvertimeDetails: "hide details",
  projectStarted: "Project {0} started",
  serviceCallStarted: "Servicecall {0} started",
  serviceCallFinished: "Servicecall {0} finished",
  commentLengthError: "Comment cannot be longer than 400 characters",
  saveChangeRequest: "Möchten Sie die Änderungen wirklich speichern?",
  noProjectSelected: "Noch kein Projekt ausgewählt!",
  noTimeAccountForDay: "There is no time account for this day",
  timeAccountCorrection: "Time account correction",

  // Models
  excludePeriods: "Exclude periods",
  deleteWeekModelMessage: "Do you really want to delete the weekly {0} model?",
  everyWeek: "every week",
  everySecondWeek: "every second week",
  everyThirdWeek: "jede third week",
  monthly: "monthly",

  //UserProjectPermissions.vue
  projectPerms: "Project stage permissions and assignments",
  selectUserHint: "Select user",
  selectDepartmentHint: "Select departament",
  selectUsersHint: "Mirror permission to the following users:",
  mirroringSubProject: "Mirror projectstage permission to the following users:",
  mirroringProject: "Mirror project permissions to the following users: (Only the stage permissions)",
  mirroringActivity: "Mirror activitytypes permissions to the following users:",
  mirroringActive: "Mirror permissions to other users",
  mirroringAll: "All",
  mirroringAllSelected: "Only selected",
  mirroringOnlySelectedProject: "Only selected project",
  mirroringOnlySelectedStage: "Only selected stage",
  mirroringStage: "Mirror stage permissions to other users:",
  mirroringAllStages: "For all stages",
  chooseMirroringType: "Please choose the permissions which get mirrored:",
  userProjectPermissionSearchState: "Search for status of the project",
  userProjectPermissionSearchCode: "Search for business partner code",
  userProjectPermissionSearchName: "Search for business partner name",
  searchCheckbox: "Do you want to search for projects?",
  noProjects: "No projects found or no projects available",
  searchDescriptionProject: "Search for projects:",
  businessPartnerCode: "Business partner code:",
  businessPartnerName: "Business partner name:",
  permissionOnOff: "Permissions On/Off",
  errorOnlyNumbers: "In the field planned Costs and planned hours only numeric values are allowed. A maximum of only 10 numbers are allowed",
  stateStarted: "Gestartet",
  stateStopped: "Gestoppt",
  statePaused: "Angehalten",
  stateCanceled: "Abgebrochen/Storniert",
  stateFinished: "Fertig",
  plannedCosts: "Planned costs in € per hour",
  plannedTime: "Planned time in hours",

  //UserServiceCallPermissions.vue
  serviceCallPermissions: "Servicecalls permissions and assignments",
  noServiceCalls: "No servicecalls available",
  noServiceTypes: "No activitytypes available",
  searchTitle: "Suche:",
  stagesTitle: "Stufen",
  noBusinessPartners: "No business partners available",
  serviceCalls: "Servicecalls",
  serviceTypes: "Activitytypes",
  searchBusinessPartners: "Do you want to search for business partners?",
  searchDescriptionServiceCall: "Search for Servicecall:",
  searchDescriptionCustomer: "Search for business partner:",
  businessPartner: "Business partner",
  userServiceCallPermissionSearchState: "Search for status of the service call",
  userServiceCallPermissionSearchSubject: "Search for subject of the service call",
  mirroringServiceCallSelected: "Only selected servicecalls",
  mirroringServiceCallSelectedAll: "All from selected servicecall",
  mirroringCustomerSelected: "Only selected business partner",
  mirroringCustomer: "Mirror Business Partner - Servicecalls and Activitytype Permissions from the business partner to the selected users",
  mirroringServiceTypeSelected: "Only selected servicecall",
  mirroringAllSelectedCustomer: "All from selected business partner",
  mirroringServiceCall: "Mirror servicecall permission to the selected users",
  mirroringServiceType: "Mirror activitytypes permission to the selected users",
  userServiceCallPermissionSearchId: "Search for servicecall id",
  userServiceCallPermissionSearchCustomerCode: "Search for business partner code",
  userServiceCallPermissionSearchName: "Search for business partner name",
  //StageProjectDialog
  noProjectsWithPermission: "No projects with permissions found",
  noServiceCallsWithPermission: "No sevicecalls with permissions found",

  //TimeReport
  exportBtn: "Export",
  exportBtnAll: "Export All",
  timeReport: "Time Report",
  selectTimeReport: "Select time report",
  monthly: "Monthly",
  timePeriod: "Time Period",
  timeBlocks: "Time Block",
  workingTime: "Working Time",
  timeIs: "Is",
  timeDebit: "Debit",
  timeBalance: "Balance",
  work: "Work",
  selectAllEmployees: "Alle Mitarbeiter auswählen",
  help: "Hilfe",
  holidays: "Jährliche Urlaubstage",
  logoNotUpdated: "Logo konnte nicht geändert werden!",
  absenceForDateAlreadyExists: "Abwesenheit für dieses Datum existiert bereits!",
  absenceAccountNotExists: "Ohne Urlaubskonto kann keine Abwesenheit angelegt werden!",
  holidayAccount: "Urlaubskonto",
  holidaysExpired: "Urlaubstage verfallen im nächsten Jahr",
  closeTimemodel: "Zeitmodell entfernen",
  closeTimemodelDateWithClock: "Schließungsdatum (Um 00:00 Uhr)",
  closeTimemodelDate: "Schließungsdatum",
  createNewTimemodel: "Neues Zeitkonto erstellen",
  deleteTimemodelQuestion: "Möchten Sie wirklich das Zeitkonto zum angegebenen Datum schließen?",
  cancelDeleteTimemodelQuestion: "Do you really want to abort the closing of the timeaccount?",
  todayWorktime: "Heutige Arbeitszeit",
  hours: "Std.",
  worked: "gearbeitet",
  totalVacation: "Gesamturlaub",
  open: "offen",
  planned: "verplant",
  taken: "genommen",
  unconfirmed: "unbestätigt",
  days: "Tage",
  showMonthlyHistorie: "Monatliche Historie öffnen",
  timeAccountIsClosing: "Zeitkontoschließung ist vorgemerkt!",
  timeModelNotSelected: "Zeitmodell wurde nicht ausgewählt",
  deleteTimemodelNowQuestion: "Möchten Sie wirklich das Zeitkonto löschen?",
  openBookingLinesWillBeDeleted: "The last booking lines will be deleted",
  employeeInformation: "Informationen anzeigen",
  absenceNotPossibleBookingsAvailable: "Abwesenheitsantrag nicht möglich, da im Zeitraum Zeitbuchungen vorliegen!",
  absenceForUserNotPossibleBookingsAvailable: "Absence request for {0} is not possible. There is a booking for this date!",
  absenceNotPossibleHolidayAvailable: "Absence request is not possible. There is a public holiday for this date!",
  userNotFoundPasswordNotMatch: "Benutzer wurde nicht gefunden oder Password ist falsch!",
  userIsInactiveInSAP: " Zugriff ist verweigert! Benutzer ist Inaktiv in SAP",
  dateWithAbsenceBookingNotPossible: "Für diesen Tag ist eine Abwesenheit eingetragen. Zeitbuchung ist nicht möglich!",
  addDailyModel: "Tageszeitmodell hinzufügen",
  addWeeklyModel: "Wochenzeitmodell hinzufügen",
  addAutoWeekModel: "Add automatic weeklymodel",
  saveDailyModel: "Tageszeitmodell speichern",
  saveWeeklyModel: "Wochenzeitmodell speichern",
  newWeeklyModel: "Neuer Wochenzeitplan",
  newAutoWeeklyModel: "New automatic weeklymodel",
  dailyModelNotSelected: "Daily model was not selected!",
  weeklyModelName: "Wochenzeitmodell Bezeichnung",
  timeIsRequired: "Time is required",
  newDailyModel: "Neuer Tageszeitplan",
  timemodelName: "Zeitmodell Bezeichnung",
  debitWorkTime: "Sollarbeitszeit",
  remark: "Bemerkung",
  worktime: "Worktime",
  pauses: "Pausen",
  inHours: "in Stunden",
  weeklyWorkTime: "Wochenarbeitszeit",
  stages: "Stufen",
  noPermission: "Kein Berechtigung!",
  wrongOTPToken: "Falscher Token!",
  passwordSettings: "Passwort Einstellungen",
  enable: "Aktivieren",
  activateOTP: "Aktiviere Zwei-Faktor Authentifikation",
  nameIsRequired: "Name is required",
  maximumCharacterLengthReached: "Maximum character length reached",
  editDailyModel: "Edit dailymodel",
  editWeeklyModel: "Edit weeklymodel",
  newEditWeeklyModel: "Edit automatic weeklymodel",
  startHolidays: "Starting holidays",
  changeStartTime: "Do you really want to change the starting value? This will correct every timeaccount booking! This will take some time!",
  oneChangeByTimeAccount: "Do you really want to change the {0}? This will correct every timeaccount booking! This will take some time!",
  timeAccountStartValue: "starting value",
  timeAccountStartDate: "starting date",
  timeAccountModell: "time model",
  twoChangesByTimeAccount: "Do you really want to change the {0} und {1}? This will correct every timeaccount booking! This will take some time!",
  changeStartTimeAndStarDateAndWeekModel:
    "Do you really want to change starting value, starting date und time model ändern? This will correct every timeaccount booking! This will take some time!",
  timeAccountNotUpdated: "TimeAccount could not be changed!",
  pinLoginNotAllowed: "PIN Login not allowed!",
  noHolidayAccount: "The employee has no holidayaccount!",
  noHolidayAccountForUser: "{0} has no holidayaccount!",

  enterYearlyHolidays: "Bitte jährliche Urlaubstage eintragen!",
  couldntAddOTPToUser: "Could not activate OTP for user!",
  deactivate: "Deactivate",
  activate: "Activate",
  twoFactorInfo1: "Don't wait for activating the two factor authentification!",
  twoFactorInfo2: "It is not hard to activate and it will help secure your personal account!",
  twoFactorInfo3: "Also you get the benefit to login into your account with an 4 digit pin. (+6 digit OTP Token)",
  twoFactorInfo4: "You then don't need to remember a complex password. Only a simple 4 digit pin.",
  twoFactorInfo5: "The 2-Factor Authentication is optional but you will benefit from it with adding a second security layer to your account.",
  twoFactorScanCodeInfo: "Scan this QR Code with your phone and type in the resulting OTP code from your phone!",
  enableTwoFactor: "Activate 2-Factor Authentication",
  twoFactor: "2-Factor Authentication",
  status: "Status",
  enterOTPCode: "Please enter the one time password from the authenticator app!",
  enterCorrectStartTimeFormat: 'Wrong Format ("+/- HH:mm")',
  showPin: "Show own Loginpin!",
  showPinInfo: "Do you really want show your login pin? Watch out that only you can see your own pin and no one else!",
  hidePin: "Hide login pin!",
  emptyTimeAccountOnMonthStart: "Empty the timeaccount to month start (Temporary basis for example.)",
  noActiveTimeAccount: "No active Timeaccount. Please add an timeaccount to insert bookinglines.",
  timeModels: "Time models",
  addAbsence: "Add absence",
  absenceAsAdmin: "Can't add absence as admin user!",
  removeVacation: "Remove vacation",
  removeAbsence: "Remove absence",
  addReasonAbsence: "Add absencereason",
  removeAbsenceQuestion: "Do you want to remove this absence?",
  addAbsenceReasons: "Add absence reasons",
  designation: "designation",
  red: "Red",
  purple: "Purple",
  blue: "Blue",
  cyan: "Cyan",
  indigo: "Indigo",
  violet: "Violet",
  orange: "Orange",
  brown: "Brown",
  checkInput: "Please enter an absence name!",
  statusInHouse: "In House",
  statusOut: "Out of House",
  statusVacation: "In Vacation",
  statusHomeOffice: "In Home Office",
  statusIll: "Ill",
  addAttachment: "Add attachment"
};
